<script>
export default {
  name: "MobileMappingSignupJourney",
  data: () => ({
    step1: require("@/assets/step1.png"),
    step2: require("@/assets/step2.png"),
    step3: require("@/assets/step3.png"),
    step4: require("@/assets/step4.png")
  })
}
</script>

<template>
<div>
  <div class="h2 mb-5 new-font-medium">In vier Schritten zum Service</div>
  <v-row>
    <v-col cols="12" sm="3">
      <div class="step-sheet">
        <img :src="step1" width="40px" height="40px" />
        <div class="step-sheet-title">Anfrage stellen</div>
        <p class="mt-2">Nehmen Sie über das Formular Kontakt zu uns auf</p>
      </div>
    </v-col>
    <v-col cols="12" sm="3">
      <div class="step-sheet">
        <img :src="step2" width="40px" height="40px" />
        <div class="step-sheet-title">Details klären</div>
        <p class="mt-2">Wir klären gemeinsam alle Details zum gewünschten Zugang</p>
      </div>
    </v-col>
    <v-col cols="12" sm="3">
      <div class="step-sheet">
        <img :src="step3" width="40px" height="40px" />
        <div class="step-sheet-title">Lizenz erwerben</div>
        <p class="mt-2">Sie erhalten einen exklusiven Zugang für Ihre Kommune</p>
      </div>
    </v-col>
    <v-col cols="12" sm="3">
      <div class="step-sheet">
        <img :src="step4" width="40px" height="40px" />
        <div class="step-sheet-title">Daten nutzen</div>
        <p class="mt-2">Sie können alle Funktionen der Work Version nutzen</p>
      </div>
    </v-col>
  </v-row>
</div>
</template>

<style scoped>
.step-sheet {
  border-radius: 5px;
  width: 100%;
  background: #FFFFFF;
  padding: 16px;
}

.step-sheet-title {
  font-family: "GeometriaMedium", sans-serif;
}
</style>